// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3O7rP","alertIcon":"ConfirmModal_alertIcon__1xQIy"};